module.exports = __webpack_public_path__ + "assets/img/wechat.118e0aff.jpg";